/* eslint-disable */
import React from 'react';
import styles from './ShortcutsModal.module.css';
import { modKeyLabel } from '../utils/shortcutLabel';

/**
 * ShortcutsModal — Brief F.2 Phase 2 redesign.
 *
 * Centered modal listing keyboard shortcuts grouped by section.
 * Migrated from inline-style to CSS module with New DNA tokens
 * scoped to .modalRoot (Convention #68).
 *
 * Triggered by '?' key (see App.js shortcut bindings). Closes on:
 *   - Click outside (backdrop)
 *   - ESC key (handled at App.js level — passed onClose)
 *   - Close × button
 *
 * Props:
 *   onClose — function, called on all close affordances.
 */
const SHORTCUTS = [
  {
    section: 'Global',
    items: [
      { keys: ['?'], action: 'Show keyboard shortcuts' },
      { keys: [modKeyLabel(), 'K'], action: 'Global search' },
      { keys: ['Esc'], action: 'Close modal / panel' },
      { keys: ['N'], action: 'New item (originals)' },
      { keys: ['A'], action: 'Open Activity drawer' },
    ],
  },
  {
    section: 'QC Manager Review',
    items: [
      { keys: ['J', 'K'], action: 'Navigate sections' },
      { keys: ['←', '→'], action: 'Swap issue type' },
      { keys: ['N'], action: 'Add new issue' },
    ],
  },
  {
    section: 'Navigation',
    items: [
      { keys: ['/'], action: 'Focus search bar' },
    ],
  },
];

export function ShortcutsModal({ onClose }) {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className={styles.modalRoot} role="dialog" aria-modal="true" aria-label="Keyboard shortcuts">
      <div className={styles.backdrop} onClick={handleBackdropClick} aria-hidden="true" />
      <div className={styles.box}>
        <div className={styles.head}>
          <div>
            <div className={styles.headEyebrow}>Keyboard Shortcuts</div>
            <div className={styles.headTitle}>CLB Operations Hub</div>
          </div>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={onClose}
            aria-label="Close shortcuts"
          >
            {'×'}
          </button>
        </div>

        <div className={styles.body}>
          {SHORTCUTS.map((group) => (
            <div key={group.section}>
              <div className={styles.sectionLabel}>{group.section}</div>
              {group.items.map((s, i) => (
                <div key={i} className={styles.row}>
                  <span className={styles.rowLabel}>{s.action}</span>
                  <div className={styles.keys}>
                    {s.keys.map((k, j) => (
                      <React.Fragment key={j}>
                        {j > 0 && <span className={styles.kbdSep}>+</span>}
                        <span className={styles.kbd}>{k}</span>
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        <div className={styles.foot} data-hide-on-touch>Press ESC to close</div>
      </div>
    </div>
  );
}
